export default "__VITE_ASSET__e0SJv2As__"